import { ActivityIndicator, Platform, View } from 'react-native'
import Animated from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import { colors } from '@ui/colors'
import Button from '@ui/buttons/Button'
import Status from '@ui/elements/Status'
import Typography from '@ui/typography'
import { useAnimatedOpacity } from '@ui/animated/useAnimatedOpacity'
import { AppVersionProps } from './types'
import PressableIcon from '@ui/buttons/PressableIcon'

const sAbsolute = 'absolute right-0 top-0 h-full flex items-center flex-row'
const row = { height: 24 }
const container = {
  gap: Platform.select({ default: 0, web: 4 }),
  paddingTop: Platform.select({ default: 23, web: 32 }),
}

interface Props extends AppVersionProps {
  index: number
  maxRows?: number
  className?: string
  onClose?: () => void
}

export default function VersionDetails({
  title,
  status,
  rows,
  button,
  action,
  index,
  loading = false,
  maxRows,
  onClose,
  actionClose,
  className,
}: Props) {
  const sLoadingTrue = useAnimatedOpacity(!!loading)
  const sLoadingFalse = useAnimatedOpacity(!loading)

  // const defaultRowsHeight =
  //   rows.length * row.height +
  //   (rows.length - 1) * container.gap +
  //   container.paddingTop

  const rowsToShow = maxRows ? rows.slice(0, maxRows) : rows

  return (
    <View
      className={cn(
        'relative inset-0 border-t border-black/10 p-8',
        index === 0 && 'border-0',
        className
      )}
    >
      <View
        className={cn(
          'flex flex-row items-center justify-between',
          (title || status) && 'h-8'
        )}
      >
        <View className="flex flex-row items-center gap-2">
          <Typography variant="MDB">{title || ''}</Typography>
          {/* {action && <Button size="xs" {...action} />} */}
          {action && !loading && (
            <PressableIcon
              className="h-8 w-8"
              {...action}
              onPress={() => {
                action.onPress?.()
                if (actionClose) {
                  onClose?.()
                }
              }}
            />
          )}
        </View>
        {status && (
          <View className="relative inset-0 flex h-full flex-1 flex-row items-center justify-end">
            <Animated.View style={sLoadingFalse} className={sAbsolute}>
              <Status
                text={status.text}
                variant={status.variant}
                className="self-center"
              />
            </Animated.View>
            <Animated.View style={sLoadingTrue} className={sAbsolute}>
              <ActivityIndicator color={colors.text} size="small" />
            </Animated.View>
          </View>
        )}
      </View>
      {/* <Collapsible fullWidth open={true} defaultHeight={defaultRowsHeight}> */}
      <View className={cn('flex flex-col gap-8')}>
        <View className={cn('flex flex-col')} style={title ? container : {}}>
          {rowsToShow.map(({ label, value }, index) => (
            <View
              key={index}
              className="flex flex-row items-start justify-between gap-4"
              style={{ minHeight: row.height }}
            >
              <Typography
                variant={Platform.select({ default: 'XS', web: 'SM' })}
                className="text-left color-desc"
              >
                {label}
              </Typography>
              <Typography
                variant={Platform.select({ default: 'XSB', web: 'SMB' })}
                style={sLoadingFalse}
                className="flex flex-row items-center gap-0 text-right"
              >
                {value}
              </Typography>
            </View>
          ))}
        </View>
        {button && (
          <Button
            size="xs"
            className="w-max self-start"
            variant="outlined"
            {...button}
          />
        )}
      </View>
      {/* </Collapsible> */}
    </View>
  )
}
